const EMPTY = 0;

/** 可暂停 / 继续的一次性定时器。暂停后剩余时长被保留，继续时从剩余时长接着走 */
export class SafeTimeout {
  private timerId: number = EMPTY;
  private callback: () => void = () => {};
  private delay: number = 0;
  private startTime: number = 0;
  private remaining: number = 0;
  private isRunning: boolean = false;
  private isPaused: boolean = false;

  public static create(): SafeTimeout {
    return new SafeTimeout();
  }

  public start(delay: number, callback: () => void) {
    if (this.isRunning) {
      return;
    }

    this.isRunning = true;
    this.isPaused = false;
    this.callback = callback;
    this.delay = delay;
    this.remaining = delay;
    this.startTime = performance.now();

    this.timerId = window.setTimeout(() => {
      // 先落终态再回调：回调中可能重新 start 同一个实例
      this.clear();
      this.remaining = 0;
      callback();
    }, delay);
  }

  public pause() {
    if (!this.isRunning) {
      return;
    }

    const remaining = this.remaining - (performance.now() - this.startTime);
    this.clear();
    // 后台标签页的 setTimeout 会被节流，暂停时可能已经过期；置 0 让 resume 立即触发
    this.remaining = Math.max(remaining, 0);
    this.isPaused = true;
  }

  public resume() {
    if (!this.isPaused) {
      return;
    }

    this.isPaused = false;
    this.start(this.remaining, this.callback);
  }

  public clear() {
    if (this.timerId !== EMPTY) {
      window.clearTimeout(this.timerId);
      this.timerId = EMPTY;
    }
    this.isRunning = false;
    this.isPaused = false;
  }

  public reset(): SafeTimeout {
    this.clear();
    this.remaining = this.delay;
    return this;
  }

  public getRemaining(): number {
    if (this.isRunning) {
      return this.remaining - (performance.now() - this.startTime);
    }
    return this.remaining;
  }
}
